import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLORS } from '../../styles/colors';

const SandboxCircuitItem = ({item, edit, remove}) => {
  const containerStyle = {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    background: COLORS.greyThree,
    marginTop: item.child ? 10 : 0,
    marginBottom: item.parent ? 10 : 0,
    height: 30,
    // borderBottom: '1px solid ' + COLORS.grey,
    // borderTop: '1px solid ' + COLORS.grey
  }
  const GripIcon = (
    <FontAwesomeIcon icon="grip-vertical"
      style={{width: '5%', marginRight: 5, color: COLORS.grey}}/>
  );
  if (item.child) {
    let rounds = '';
    if (item.formData) {
      if(item.formData.amrp) {
        rounds = ` - As Many Rounds as Possible in ${item.formData.amrp} min`
      }
      if(item.formData.rounds) {
        rounds = ` - ${item.formData.rounds} Rounds`
      }
      if(item.formData.emom) {
        rounds = ` - EMOM ${item.formData.emom} Rounds`
      }
    }
    return (
      <div style={containerStyle}>
        { GripIcon }
        <div style={{ width: '85%', textAlign: 'center', color: COLORS.white }}>
          <b>{`BEGIN CIRCUIT${rounds}`}</b>
        </div>
        <FontAwesomeIcon icon="times" className="link"
          onClick={remove}
          style={{width: '5%', color: COLORS.orange}}/>

        <FontAwesomeIcon icon="edit" className="link"
          onClick={edit}
          style={{width: '5%', color: COLORS.orange}}/>
      </div>
    )
  }else{
    return (
      <div style={containerStyle}>
        { GripIcon }
        <div style={{width: '85%', textAlign: 'center', color: COLORS.white}}>
          <b>END CIRCUIT</b>
        </div>
        <div style={{width:'10%'}} />
      </div>
    )
  }
}

export default SandboxCircuitItem;



// WEBPACK FOOTER //
// ./src/components/workouts/SandboxCircuitItem.js